<template>
  <div class="login">
    <div class="container" style="background-position: left;">
      <div class="loginright">
        <img class="titleimg" src="../assets/img/logintip.png" alt="">
        <el-form label-width="0px">
          <el-form-item>
          <el-input  v-model="login.username" placeholder="手机号" prefix-icon="el-icon-user" clearable></el-input>
          </el-form-item>
          <el-form-item>
          <el-input placeholder="密码" v-model="login.password" show-password prefix-icon="el-icon-lock"></el-input>
          </el-form-item>
        </el-form>
        <div class="go-login"  @click="loginfn">登 录</div>
        <div class="other-info">
          <div class="cursor" @click="updatepwd()">找回密码</div>
          <div class="go-register cursor" @click="topath('/register',{},false)">
            没有账号？ 立即注册
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="找回密码"
      width="400px"
      :visible.sync="centerDialogVisible"
      center>
      <UpdatePwd :key="num+'key'" ref="updatepwd" @successpost="centerDialogVisible = false" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="postUpdate">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import UpdatePwd from '../components/updatePwd.vue'
export default {
  name: 'login',
  components:{UpdatePwd},
  data() {
    return {
      radio:'1',
      show:'0',
      active:1,
      login:{
        username:'',
        password:'',
      },
      centerDialogVisible:false,
      num:1,
	  redirect:null,
	  openWebUrl:null,
	  oldUrl:null
    }
  },
  created(){
    // this.getinfo();
	this.openWebUrl=this.$route.query.openWebUrl||null
	this.redirect=this.$route.query.redirect||null
	this.oldUrl=this.$route.query.oldUrl||null
  },
  methods:{
    postUpdate(){
      this.$refs.updatepwd.postdata()
    },
    updatepwd(){
      this.num+=1;
      this.centerDialogVisible = true;
    },
    loginfn(){
      this.HTTP.post(this.$api.login,this.login)
      .then((res={})=>{
        if(res.token){
          localStorage.setItem('token',res.token)
          this.getinfo();
        }
      })
    },
    // 获取用户信息
    getinfo(){
       this.HTTP.get(this.$api.user_getInfo,{token:localStorage.getItem('token')})
      .then((res={})=>{
        if(res){
          this.$store.commit('setUserinfo',res.user)
		  if(this.redirect){
			  if(this.openWebUrl){
				  window.open(this.redirect)  
				  this.$router.push({path:this.oldUrl})
			  }else{
				  this.$router.push({path:this.redirect})
			  }
			   
		  }else{
			   this.$router.push({path:'/'})
		  }
         
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.login {
  font-size: 0;
  height: calc(100% - 349px);
  .container {
      background: url('../assets/img/loginback.png') 90px center no-repeat;
      position: relative;
      overflow: hidden;
      background-position:left;
  }
  .loginright {
    float: right;
    padding: 15px 15px 10px;
    margin: 110px 0;
    width: 320px;
    .titleimg {
      width: 100%;
      height: auto;
      margin-bottom: 50px;
    }
    .input-line {
      border-bottom: 1px solid #dadada;
      height: 60px;
      line-height: 60px;
      position: relative;
      overflow: hidden;
    }
    .go-login {
      font-size: 14px;
      color: #fff;
      text-align: center;
      display: inline-block;
      margin: 18px 0;
      width:100%;
      padding: 10px 0;
      cursor: pointer;
      background-image: linear-gradient(to right,#00366a, #397c97);
    }
    .other-info {
      padding: 10px 0;
      font-size: 12px;
      text-align: right;
      font-weight: bold;
      // color: $--color-primary;
      color: #387b95;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
    }
  }
  
}

</style>